import { MOCK_MY_INFO } from '../mock-data/me.mock';
import { createMockResponse } from '../mock.interceptor';

import type { MyInfoApiResponse } from '../../features/me/me.models';
import type { HttpResponse } from '@angular/common/http';
import type { Observable } from 'rxjs';

/**
 * /api/v0/me へのリクエストをハンドリング
 */
export function handleMeRequest(
  method: string,
  path: string,
): Observable<HttpResponse<unknown>> | null {
  // GET /api/v0/me - 自分の情報取得
  if (method === 'GET' && path === '/api/v0/me') {
    return handleGetMe();
  }

  return null;
}

/**
 * GET /api/v0/me - 自分のアカウント情報取得
 */
function handleGetMe(): Observable<HttpResponse<MyInfoApiResponse>> {
  return createMockResponse<MyInfoApiResponse>(MOCK_MY_INFO);
}
